import React from 'react';
import SearchIcon from '@mui/icons-material/Search';
import EditText from '../../../base/edit-text/edit-text';
import { SearchBarStyled } from './search-bar.styled';
import { EdiTextVariant } from '../../../base/edit-text/constants';
import { Colors } from '../../../../colors';

export interface SearchBarProps {
  label: string,
  handleChange: (event: any) => void,
  placeholder: string
}

const SearchBar = (props: SearchBarProps) => {


  return (
    <SearchBarStyled.Container>
      <SearchBarStyled.ContainerEdit>
        <EditText variant={EdiTextVariant.Standard} placeholder={props.placeholder} onChange={props.handleChange} label={props.label} />
      </SearchBarStyled.ContainerEdit>
      <SearchIcon sx={ { color: Colors.DarkGrey }}/>
    </SearchBarStyled.Container>
  );
};


export default SearchBar;
